import React from 'react';
import styles from './StatusBadge.module.css';

export interface StatusBadgeProps {
  text: string;
  variant?: 'default' | 'success' | 'warning' | 'error' | 'info' | 'neutral';
  customColors?: {
    background: string;
    text: string;
  };
  size?: 'small' | 'medium' | 'large';
  className?: string;
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({
  text,
  variant = 'default',
  customColors,
  size = 'medium',
  className
}) => {
  const getVariantStyles = () => {
    if (customColors) {
      return {
        backgroundColor: customColors.background,
        color: customColors.text
      };
    }

    switch (variant) {
      case 'success':
        return { backgroundColor: 'var(--shamrock-green)', color: 'white' };
      case 'warning':
        return { backgroundColor: 'var(--jaffa)', color: '#000000' };
      case 'error':
        return { backgroundColor: 'var(--wild-watermelon)', color: 'white' };
      case 'info':
        return { backgroundColor: 'var(--global-separator-color)', color: 'var(--font-color)' };
      case 'neutral':
        return { backgroundColor: 'var(--global-separator-color)', color: 'var(--font-color)' };
      default:
        return { backgroundColor: 'var(--global-separator-color-light)', color: 'var(--font-color)' };
    }
  };

  const getSizeStyles = () => {
    switch (size) {
      case 'small':
        return { padding: '4px 8px', fontSize: '10px' };
      case 'large':
        return { padding: '8px 16px', fontSize: '14px' };
      default:
        return { padding: '6px 12px', fontSize: '12px' };
    }
  };

  const badgeStyles = {
    ...getVariantStyles(),
    ...getSizeStyles()
  };

  return (
    <div 
      className={`${styles.statusBadge} ${styles[size]} ${className || ''}`}
      style={badgeStyles}
    >
      {text}
    </div>
  );
};
